/* eslint-disable prettier/prettier */
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import ResultsModal from '../../vendasOnlineParceiro/components/ResultsModal';

const Results = ({ location, router }) => {
  const actionId = location?.query?.action;
  const activity = useMemo(
    () => (actionId ? { id: parseInt(actionId, 10), name: 'Link de Pagamento' } : null),
    [actionId]
  );

  const handleClose = () => {
    if (location?.query?.from === 'inicio') {
      router.push('/owner/acoes/inicio');
      return;
    }
    router.push('/owner/acoes/minhas-atividades');
  };

  useEffect(() => {
    if (!activity?.id) {
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activity]);

  if (!activity?.id) {
    return null;
  }

  return <ResultsModal open onClose={handleClose} activity={activity} />;
};

Results.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.shape({
      action: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      from: PropTypes.string,
    }),
  }).isRequired,
  router: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

export default Results;
